module.exports = __webpack_public_path__ + "static/img/level710.2140b368.png";